/** Official annual schedule. Update this table when the State Council publishes a new year.
 * Source: https://www.beijing.gov.cn/fuwu/bmfw/sy/jrts/202511/t20251104_4258838.html
 * Published 2025-11-04, 国办发明电〔2025〕7号. Unknown years fall back to user weekdays.
 */
export const CHINA_HOLIDAY_YEARS = [2026];
const holidays: Record<string, string> = {};
for (const [month, start, end, name] of [
  [1, 1, 3, '元旦'],
  [2, 15, 23, '春节'],
  [4, 4, 6, '清明节'],
  [5, 1, 5, '劳动节'],
  [6, 19, 21, '端午节'],
  [9, 25, 27, '中秋节'],
  [10, 1, 7, '国庆节'],
] as const) {
  for (let day = start; day <= end; day++)
    holidays[`2026-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`] = name;
}
const makeup = new Set([
  '2026-01-04',
  '2026-02-14',
  '2026-02-28',
  '2026-05-09',
  '2026-09-20',
  '2026-10-10',
]);
export function chinaCalendarDay(date: Date) {
  const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return {
    holiday: holidays[key],
    makeup: makeup.has(key),
    covered: CHINA_HOLIDAY_YEARS.includes(date.getFullYear()),
  };
}
